module.exports = __webpack_public_path__ + "static/media/recent_answer_no_content.0356f4ef.png";